export default "__VITE_ASSET__36249a66__"